import { createContext, useState } from 'react';

import PhoneTypeData from './PhoneTypeData';

export const PhoneTypeStateContext = createContext();

const PhoneTypeContextProvider = ({ children }) => {
  const stateHook = useState(PhoneTypeData.INITIAL_STATE);

  return (
    <PhoneTypeStateContext.Provider value={stateHook}>
      {children}
    </PhoneTypeStateContext.Provider>
  );
};

export default PhoneTypeContextProvider;